import { useLayoutEffect, useEffect } from 'react';

/**
 * Regular layout effect can't be used in NextJS because they are not
 * supported while Server Side Rendering.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
